export default {"src":"/_next/static/media/KYB_DISABLED.515436bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};